import { useQuery } from "@tanstack/react-query";
import { TableCard } from "ui-components/Layout";
import { ListLayout } from "ui-components/Layout";
import BasicTable from "ui-components/tables/BasicTable";
import { InterDivisioninventoriesColumns } from "./columns";
import { useState } from "react";
import { useCustomerValue } from "providers/CustomerContext";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useTeamValue } from "providers/TeamContext";
import dayjs from "dayjs";
import { Grid } from "@mui/material";
import { LoadingDialog } from "ui-components/Alert";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";
import { ExportDialog } from "ui-components/Alert";
import { getInterDivisionInventoriesEnquiry } from "services/data.report.service";
import { SelectField } from "../components/Form";
import { SelectFields } from "ui-components/Form";
import { getDivisionGroupOptions } from "services/data.internal.service";

function InterDivisionInventoriesEnquiry() {
  const { permissions, allowAll } = useTeamValue();
  const { customerCode } = useCustomerValue();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const exportPermission =
    allowAll ||
    (Boolean(permissions["Inter-Division Inventories_Report"]) &&
      permissions["Inter-Division Inventories_Report"].findIndex((b) => b === "export") !== -1);

  const [alert, setAlert] = useState(null);
  const { isDownloading, downloadCsv } = useCsvDownloadHook();

  const [divisionGroupOpt, setDivisionGroupOpt] = useState([]);
  const [selectedDivisionGroup, setSelectedDivisionGroup] = useState("");

  useQuery({
    queryKey: ["division-group-options", { customerCode }],
    queryFn: () => getDivisionGroupOptions({ customerCode }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => {
      const options = data.data.data.map((v) => v);
      setDivisionGroupOpt(options);
    }
  })

  const handleFilterRowsChange = (filteredData) => {
    setFilteredData(filteredData);
  };

  const [columns, setColumns] = useState(InterDivisioninventoriesColumns);

  const { refetch, isFetching } = useQuery({
    queryKey: ["inter-division-inventories-enquiry", { customerCode, selectedDivisionGroup }],
    queryFn: () => getInterDivisionInventoriesEnquiry({ customerCode, selectedDivisionGroup }),
    enabled: Boolean(customerCode) && Boolean(selectedDivisionGroup),
    onSuccess: (data) => {
      const result = data.data.data;
      const customers = [...new Set(result.map(x => x.customerCode))];
      setColumns([
        ...InterDivisioninventoriesColumns,
        ...customers.map(c => ({
          header: c,
          accessorKey: c
        }))
      ]);
      const flattened = Object.values(
        result.reduce((acc, row) => {
          const key = `${row.warehouseCode}|${row.skuCode}`;

          if (!acc[key]) {
            acc[key] = {
              warehouseCode: row.warehouseCode,
              skuCode: row.skuCode
            };

            customers.forEach(c => acc[key][c] = 0); // numeric temp
          }

          acc[key][row.customerCode] += Number(row.balanceQuantity);

          return acc;
        }, {})
      ).map(row => {
        // convert numeric columns back to string
        customers.forEach(c => {
          row[c] = String(row[c]);
        });
        return row;
      });

      setData(flattened);
      setFilteredData(flattened);

    },
    onError: () => { },
  });
  return (
    <ListLayout>
      {isFetching && <LoadingDialog />}
      {isDownloading && <ExportDialog />}
      {alert && <MDBox sx={{ my: 3 }}>{alert}</MDBox>}
      <TableCard sx={{ my: 3 }}>
        <MDBox margin="1rem 0 0 1rem">
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <SelectFields
                field={{
                  name: "divisionGroup",
                  label: "Division Group",
                  value: selectedDivisionGroup,
                  errors: {},
                }}
                options={divisionGroupOpt}
                onChange={(e, option) => {
                  setSelectedDivisionGroup(option)
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <MDButton
                sx={{ marginLeft: "1rem" }}
                variant="gradient"
                color="info"
                disabled={!exportPermission}
                onClick={() => {
                  const filename = `${customerCode}_${dayjs(new Date()).format(
                    "YYYYMMDD-HHmm"
                  )}_Inter-Division-Inventories`;
                  downloadCsv(
                    filename,
                    filteredData.map((x) => {
                      const { ...d } = x;
                      return {
                        ...d
                      };
                    })
                  );
                }}
              >
                Export
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
        <BasicTable
          data={data}
          columns={columns}
          onFilterRowsChange={handleFilterRowsChange}
        />
      </TableCard>
    </ListLayout>
  );
}

export default InterDivisionInventoriesEnquiry;
